export function useBaseParams() {
    const searchParams = new URLSearchParams(
      window.location.search.toLowerCase()
    );
    return {
      chainId: searchParams.get("chainid"),
      Lang: searchParams.get("lang") || 'en'
    };
  }